import _toConsumableArray from "/srv/nobackup/gitlabrunner/builds/t1_tyu7Co/0/entente-lot/lvdlr-2020-front/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/srv/nobackup/gitlabrunner/builds/t1_tyu7Co/0/entente-lot/lvdlr-2020-front/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

import Downsampler from 'downsample-lttb';
import { addEvent, removeEvent } from '@qogni/dygraphs/src/dygraph-utils';
import Dygraphs from '@qogni/dygraphs';

var getRangeSelectorCanvas = function getRangeSelectorCanvas(dygraph) {
  return dygraph.plugins_.find(function (p) {
    return p.plugin instanceof Dygraphs.Plugins.RangeSelector;
  }).plugin.fgcanvas_;
};

var Downsample = function Downsample(options) {
  var _this = this;

  _classCallCheck(this, Downsample);

  this.mousedownHandler = function (e) {
    _this.mousedown = true;
  };

  this.mouseupHandler = function (e) {
    if (_this.mousedown) {
      _this.dygraph.updateOptions({
        file: _this.dygraph.file_
      }, false);

      _this.mousedown = false;
    }
  };

  this.rangeSelectorHandler = function (e) {
    _this.mousedown = true;
  };

  this.activate = function (dygraph) {
    var from;
    var to;

    var extractSeries = function extractSeries(rawData, seriesIndex, options) {
      var newData = [];
      var series = [];

      for (var i = 0; i < rawData.length; i++) {
        series.push([rawData[i][0], rawData[i][seriesIndex]]);
      }

      var leftBoundary = series.findIndex(function (data) {
        return data[0] >= from;
      });
      var rightBoundary = series.findIndex(function (data) {
        return data[0] >= to;
      });

      if (leftBoundary > 0) {
        newData = newData.concat(Downsampler.processData(series.slice(0, leftBoundary), _this.invisibleThreshold));
      }

      newData = newData.concat(Downsampler.processData(series.slice(leftBoundary, rightBoundary), _this.visibleThreshold));

      if (rightBoundary < series.length) {
        newData = newData.concat(Downsampler.processData(series.slice(rightBoundary), _this.invisibleThreshold));
      }

      return newData;
    };

    _this.dygraph = dygraph;
    _this.events = [[dygraph.maindiv_, 'mousedown', _this.mousedownHandler], [window, 'mouseup', _this.mouseupHandler]];

    if (dygraph.getBooleanOption('showRangeSelector')) {
      _this.events.push([getRangeSelectorCanvas(_this.dygraph), 'mousedown', _this.rangeSelectorHandler]);
    }

    _this.events.map(function (e) {
      return addEvent.apply(void 0, _toConsumableArray(e));
    });

    var predraw = function predraw(e) {
      var _e$dygraph$xAxisRange = e.dygraph.xAxisRange();

      var _e$dygraph$xAxisRange2 = _slicedToArray(_e$dygraph$xAxisRange, 2);

      from = _e$dygraph$xAxisRange2[0];
      to = _e$dygraph$xAxisRange2[1];
      e.dygraph.dataHandler_.extractSeries = extractSeries;
    };

    return {
      predraw: predraw
    };
  };

  this.destroy = function (e) {
    _this.events.map(function (e) {
      return removeEvent.apply(void 0, _toConsumableArray(e));
    });
  };

  this.visibleThreshold = Infinity;
  this.invisibleThreshold = 100;
  this.mousedown = false;
  this.dygraph = null;

  if (options) {
    if (options.visibleThreshold) {
      this.visibleThreshold = options.visibleThreshold;
    }

    if (options.invisibleThreshold) {
      this.invisibleThreshold = options.invisibleThreshold;
    }
  }
};

export { Downsample as default };

Downsample.toString = function () {
  return 'Downsample Plugin';
};